import { AlertColor } from '@mui/material';
import { SourcedCandidateStatus } from 'generated-graphql/types';

export type SOURCING_STATUS =
  | 'CHECKING_PROFILE'
  | 'INVITE_SENT'
  | 'DUPLICATE'
  | 'INVITE_FAILED';

export const mapSourcingStatuses = (
  status: SourcedCandidateStatus
): SOURCING_STATUS => {
  switch (status) {
    case SourcedCandidateStatus.Enriching:
    case SourcedCandidateStatus.AwaitingInvite:
    case SourcedCandidateStatus.EnrichmentSuccess:
    case SourcedCandidateStatus.AwaitingEnrichment:
      return 'CHECKING_PROFILE';
    case SourcedCandidateStatus.Invited:
      return 'INVITE_SENT';
    case SourcedCandidateStatus.Duplicate:
      return 'DUPLICATE';
    case SourcedCandidateStatus.EnrichmentFailed:
      return 'INVITE_FAILED';
  }
};

export const SOURCING_STATUS_MESSAGES: Record<SOURCING_STATUS, string> = {
  CHECKING_PROFILE: 'Checking profile',
  INVITE_SENT: 'Sent',
  DUPLICATE: 'Already invited',
  INVITE_FAILED: 'Failed to send'
};

export const SOURCING_ALERT_TYPE: Record<SOURCING_STATUS, AlertColor> = {
  CHECKING_PROFILE: 'info',
  INVITE_SENT: 'success',
  DUPLICATE: 'error',
  INVITE_FAILED: 'error'
};

export const SOURCING_STATUS_SUB_TITLE: Record<SOURCING_STATUS, string> = {
  CHECKING_PROFILE: 'Gathering candidate details before sending an invite.',
  INVITE_SENT: 'Invitation sent',
  DUPLICATE: 'This email is already in your analysis.',
  INVITE_FAILED: 'The email address provided may be out of date or invalid.'
};
